import { ref } from 'vue'

export interface StatusMessage {
  id: string
  type: 'loading' | 'success' | 'error'
  message: string
}

const statusMessages = ref<StatusMessage[]>([])
const messageIdCounter = ref(0)

export const useStatusMessages = () => {
  const showMessage = (type: StatusMessage['type'], message: string, duration = 2000) => {
    const id = `msg-${messageIdCounter.value++}`
    
    statusMessages.value.push({ id, type, message })
    
    if (type !== 'loading') {
      setTimeout(() => {
        removeMessage(id)
      }, duration)
    }
    
    return id
  }

  const removeMessage = (id: string) => {
    const index = statusMessages.value.findIndex(msg => msg.id === id)
    if (index > -1) {
      statusMessages.value.splice(index, 1)
    }
  }

  const showLoading = (message: string) => showMessage('loading', message)
  const showSuccess = (message: string, duration?: number) => showMessage('success', message, duration)
  const showError = (message: string, duration?: number) => showMessage('error', message, duration)

  return {
    statusMessages,
    showMessage,
    showLoading,
    showSuccess,
    showError,
    removeMessage
  }
}